import { useCallback, useMemo, useState } from "react";
import TimelineItem from "types/TimelineItem";
import downloadFile from "utils/downloadFile";
import {
  createDownloadFilename,
  isDownloadableItem,
} from "../utils/shareDownloadUtils";

interface Params {
  timelineItems: TimelineItem[];
}

export default function useShareDownloadAll({ timelineItems }: Params) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [completedCount, setCompletedCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);

  const downloadableItems = useMemo(
    () => timelineItems.filter(isDownloadableItem),
    [timelineItems],
  );

  const downloadAll = useCallback(async () => {
    if (isDownloading || downloadableItems.length === 0) return;

    setIsDownloading(true);
    setCompletedCount(0);
    setErrorCount(0);

    let completed = 0;
    let errors = 0;

    for (const [index, timelineItem] of downloadableItems.entries()) {
      try {
        await downloadFile({
          url: timelineItem.signedSourceUrl!,
          filename: createDownloadFilename(timelineItem, index),
        });
      } catch (error) {
        errors += 1;
        console.error("Error downloading share video:", error);
      }

      completed += 1;
      setCompletedCount(completed);
      setErrorCount(errors);
    }

    setIsDownloading(false);
  }, [downloadableItems, isDownloading]);

  return {
    completedCount,
    downloadAll,
    errorCount,
    hasDownloadable: downloadableItems.length > 0,
    isDownloading,
    totalCount: downloadableItems.length,
  };
}
